<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          :has-return="true"
          @onReturn="() => $router.back()"
       />
      </div>
    </div>
    <div>
      <filter-manager  
        v-model="filterDataModel"
        ref="filterManager"
        :display-advanced="false"
        :filters="filterManagerConfig"
        :is-advanced="false"
        search-text="Procesar"
        search-icon="fa fa-sync"
        search-container-class="custom-btn-process"
        @search="processReport"
      />
    </div>
    <div class="row pl-3">
      <queue-report-status
        :queue-report="queueInfo"
        @on-cancel="cancelQueue"
        @on-download="downloadQueueReport"
      />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import ProviderServices from '@/services/api/provider.api'
import AcademicYearServices from '@/services/api/academicyear.api'
import reportApi from '@/modules/report/api'
import DocumentsService from '@//modules/report/document'
import hubService from '@/services/api/hub/hubservice.js';
import queueReportTypes from '@/utils/constants/queueReportTypes';
import QueueReportStatus from '@/views/progress/shared/components/QueueReportStatus.vue';
import queueReportStatus from '@/utils/constants/queueReportStatus';

export default {
  components: {
    PageHeader,
    FilterManager,
    QueueReportStatus,
  },
  data: () => ({
    page: {
      icon: 'fas fa-clipboard-list-check',
      title: 'Acuerdos Colaborativos Practicantes e Internos',
      routes: ["Inicio", "Acuerdos Colaborativos Practicantes e Internos"]
    },
    filterDataModel: {
      academicYear: null,
      provider: null,
      fromDate: null,
      toDate: null,
    },
    collections: {
      academicYears: [],      
      providers: [],
    },
    queueInfo: null,
  }),
  computed: {
    maxFromDate() {
      if (!this.filterDataModel.toDate) return new Date();

      let fechaString = this.filterDataModel.toDate;
      let fecha = new Date(fechaString);
      fecha.setDate(fecha.getDate() - 1);

      return fecha;
    },
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'CustomDropDown',
          options: this.collections.academicYears,
          value: this.filterDataModel.academicYear,
          class: 'col-sm-4 col-md-3',
          placeholder: 'Año Académico',
          fieldName: 'description',
          fieldKey: 'id',
          clearable: false,
          validations: 'required',
          error: 'El año académico es obligatorio.',
        },
        {
          name: 'provider',
          component: 'CustomDropDown',
          options: this.collections.providers,
          value: this.filterDataModel.provider,
          class: 'col-sm-4 col-md-3',
          placeholder: 'Proveedor',
          fieldName: 'name',
          fieldKey: 'id',
        },
        {
          name: 'fromDate',
          component: 'custom-date-picker',
          placeholder: 'Fecha Desde',
          class: 'col-sm-4 col-md-3',
          classContainer: 'w-100',
          maxDate: this.maxFromDate,
          value: this.filterDataModel.fromDate,
        },
        {
          name: 'toDate',
          component: 'custom-date-picker',
          placeholder: 'Fecha Hasta',
          class: 'col-sm-4 col-md-3',
          classContainer: 'w-100',
          maxDate: new Date(),
          minDate: this.filterDataModel.fromDate,
          value: this.filterDataModel.toDate,
        },
      ]
    },
  },
  watch: {
    async 'filterDataModel.academicYear'(newValue) {
      if (!newValue?.id) return;

      const { data } = await ProviderServices.getEligibleStudentProviders({
        academicYearId: this.filterDataModel.academicYear?.id,
      });

      this.filterDataModel.provider = null;
      this.collections.providers = [...data];
    },
    'filterDataModel.fromDate'(newValue) {
      if (!!newValue && newValue > this.filterDataModel.toDate) {
        this.filterDataModel.toDate = null;
      }
    },
  },
  async mounted() {
    await this.populateAcademicYear();
    const res = await reportApi.getPreviousGeneratedReport([
      queueReportTypes.InternTraineeAgreements,
    ]);
    this.queueInfo = res.data !== '' ? res.data : null;
  },
  created() {
    Vue.use(hubService);
    this.$userHub.$on(
      'hub-receive-status-queue-report',
      this.updateReceivedQueueStatusByHub
    );
  },
  beforeDestroy() {
    //clean SignalR event
    this.$userHub.$off(
      'hub-receive-status-queue-report',
      this.updateReceivedQueueStatusByHub
    );
  },
  methods: {
    async populateAcademicYear() {
      const { data } = await AcademicYearServices.getCurrentYearAcademicYears();
      this.collections.academicYears = [...data];
      this.filterDataModel.academicYear = this.collections.academicYears.find(x => x.selected);
    },
    async cancelQueue(executionLogId) {
      try {
        const res = await reportApi.cancelQueueReport(executionLogId);
        if (res.data) {
          this.ShowToast(
            'Proceso Exitoso',
            'La ejecución del reporte ha sido cancelada exitosamente.',
            'success'
          );
          this.queueInfo = null;
        }
      } catch (err) {
        this.ShowToast('', err.response?.data?.message, 'error');
      }
    },
    async processReport() {
      const isValid = await this.$refs.filterManager.$refs.formValidator.validate();
      if (!isValid) return;

      const params = {
        academicYearId: this.filterDataModel.academicYear.id,
        providerId: this.filterDataModel.provider?.id,
        fromDate: this.filterDataModel.fromDate
          ? new Date(this.filterDataModel.fromDate).toISOString()
          : null,
        toDate: this.filterDataModel.toDate
          ? new Date(this.filterDataModel.toDate).toISOString()
          : null
      };

      // Filtra los null/undefined (solo envía los válidos)
      const query = new URLSearchParams(
        Object.entries(params).filter(([, v]) => v != null && v !== '')
      ).toString();

      const res = await reportApi.queueReport(`InternTraineeAgreements?${query}`);
      
      this.queueInfo = {
        executionLogId: res.data,
        statusId: queueReportStatus.Pending,
        expired: false,
      };
    },
    updateReceivedQueueStatusByHub(res) {
      this.queueInfo = res.respose;
    },
    async downloadQueueReport(executionLogId) {
      reportApi.downloadQueueReport(executionLogId)
        .then((res) => DocumentsService.Download(res.data))
        .catch((err) => {
          this.ShowToast('', err.response?.data?.message, 'error');
        });
    },
  },
}
</script>

<style scope>
.custom-btn-process {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 10%;
  flex: 0 0 10%;
  max-width: 10%;
  margin-left: 0 !important;
  margin-right: 0 !important;
  margin-bottom: 0.25rem !important;
}
</style>

